module.exports = __webpack_public_path__ + "static/media/logout.6d6f865b.png";